export default {
  title: "À propos de nous",
  mission_vision: "Mission et vision",
  mission_vision_desc:
    "Notre mission est d'aider les PME à atteindre rapidement la conformité CBAM de l'UE avec une précision supérieure à 90 %, réduisant ainsi les coûts et améliorant l'efficacité, tout en soutenant les objectifs de durabilité de 2026.",
  team: "Présentation de l'équipe",
  team_desc:
    "TaxEcoBit est une plateforme SaaS de conformité CBAM construite par des professionnels, dédiée à la fourniture aux PME d'outils efficaces et fiables pour simplifier les processus de conformité et se mettre continuellement à jour pour répondre aux exigences réglementaires de l'UE.",
  contact: "Nous contacter",
  contact_email: "Email : {email}",
  follow_us: "Suivez-nous :",
  newsletter: "Newsletter",
  newsletter_desc:
    "Abonnez-vous à notre newsletter pour recevoir les dernières interprétations des politiques CBAM, des conseils de conformité et des mises à jour de fonctionnalités.",
  newsletter_button: "S'abonner",
  agreement_text:
    "J'accepte d'utiliser cet email pour recevoir les dernières interprétations des politiques CBAM, des conseils de conformité et des mises à jour de fonctionnalités, et j'accepte que mes données personnelles soient traitées conformément aux exigences du RGPD.",
  support: "Assistance instantanée",
  support_desc:
    "Nous avons compilé des FAQ pour votre recherche en libre-service rapide ; si vous avez besoin d'une aide supplémentaire, vous pouvez soumettre un ticket à tout moment, et notre équipe d'assistance répondra dans un délai de 24 à 48 heures.",
  support_button: "Contacter l'assistance",
  chat_opened: "Fenêtre d'assistance ouverte",
  newsletter_success: "Abonnement réussi : {email}",
};
